import React from 'react';

import cn from '@/helpers/utils/classNames';

const CounterBox = ({
  label,
  count,
  onClick,
}: {
  label: string;
  count: number | string;
  onClick?: (value: string) => void;
}) => {
  return (
    <div className="v2-w-full v2-flex v2-justify-between v2-flex-col">
      <p className="v2-font-sweet-sans-pro v2-font-normal v2-text-base v2-text-[#333333] v2-text-center v2-mb-2">
        {label}
      </p>
      <div className="v2-bg-[#F5F7F2] v2-rounded-xs v2-flex v2-justify-center v2-items-center v2-h-[100px]">
        <p
          className={cn(
            'v2-text-center v2-text-[32px] v2-font-sweet-sans-pro-medium v2-font-medium v2-text-[#154734]',
            {
              'v2-underline': !!onClick,
            }
          )}
          role={!!onClick ? 'button' : undefined}
          onClick={() => onClick && onClick(label)}
        >
          {count}
        </p>
      </div>
    </div>
  );
};

export default CounterBox;
